import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialCarousel = () => {
  const data = [
    {
      name: "placemynbrand.co",
      text: "Very good work, I really recommend AKCODA to everyone."
    },
    {
      name: "haneesa.in",
      text: "They built an Android app for my wholesale grocery business, and delivered on time."
    },
    {
      name: "Entdelhi.com",
      text: "I'm an ENT doctor. They delivered my website exactly as I expected."
    },
    {
      name: "cureskills.com",
      text: "We're a nursing institute. AKCODA created a registration and course-selling platform for us."
    },
    {
      name: "scardrivingschool.com",
      text: "I run a driving school. They helped me get a beautiful, on-time website."
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 3000,
    slidesToShow:3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true, // shows next/prev buttons
    responsive: [
      {
        breakpoint: 768, // tablets
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480, // mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="testimonial-wrapper" style={{background:'white'}}>
      <div className="container py-5">
        <p style={{color:'#0f0f0fff'}}>Testimonials</p>
        <h2 style={{color:'#3e13c0ff', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>What people say about us?</h2>
        <Slider {...settings}>
          {data.map((item, index) => (
            <div key={index} className="p-3">
              <div className="testimonial-card p-4 border rounded">
                <h6 className="mb-2" style={{color:'#090909ff', fontWeight:'300', fontFamily:'Bungee, sans-serif'}}>{item.name}</h6>
                <p className="m-0">{item.text}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
